export default new class loginFormModal {
  constructor() {
    this.loginFormSelector = 'login-modal__form';
    this.loginEmailInput = 'login-modal__email';
    this.loginPasswordInput = 'login-modal__password';
    this.submitBtnSelector = 'login-modal__submit';
    this.inValidSelector = '_invalid';
    this.successSelector = 'login-modal__success';
    this.successVisibleSelector = 'login-modal__success_visible';
    this.preLoaderSelector = 'login-modal__preloader';
    this.delay = 2000;

    this.handler();
  }

  handler() {
    const form = document.querySelector(`.${this.loginFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', () => {
      setTimeout(() => {
        this.checkForm(form);
      }, 0);
    });
  }

  checkForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    const formEmail = form.querySelector(`.${this.loginEmailInput}`);
    const email = formEmail.value;

    const formPassword = form.querySelector(`.${this.loginPasswordInput}`);
    const password = formPassword.value;

    $.request('Login::onAjax', {
      data: {
        email,
        password,
      },
      loading: `.${this.preLoaderSelector}`,
      complete: (res) => {
        this.showTooltip(res);
      },
    });
  }

  showTooltip(res) {
    clearTimeout(this.timer);
    const { responseJSON } = res;

    if (!responseJSON.message) return;

    const tooltip = document.querySelector(`.${this.successSelector}`);
    tooltip.classList.add(this.successVisibleSelector);
    if (!responseJSON.status) {
      tooltip.classList.add('tooltip__error');
    } else {
      tooltip.classList.remove('tooltip__error');
    }
    tooltip.innerHTML = responseJSON.message;

    this.timer = setTimeout(() => {
      tooltip.classList.remove(this.successVisibleSelector);
    }, 2000);
  }
}();
